import React from 'react';
import { ProjectsList } from '@components/projects';
// import DashboardWheelsSection from '@components/charts/DashboardWheelsSection';
import { WithPermission } from '@lib/helpers/WithPermission';
import LandingCharts from '@components/charts/LandingCharts';
import { AdvModal } from '@components/atomic/molecules';

const Projects = ({ permissions }) => {
	return (
		<div id="progetti" className="megaContent">
			<div className="container-fluid">
				<h1
					className="fw-bold"
					style={{
						marginBlock: '24px 28px',
						paddingBlock: '3px',
					}}
				>
					Progetti
				</h1>

				<WithPermission permission="view-landing-charts">
					<LandingCharts />

					{/* <DashboardWheelsSection global={true} /> */}
				</WithPermission>
				<WithPermission permission="view-projects-list">
					<ProjectsList permissions={permissions} />
				</WithPermission>

				<AdvModal />
			</div>
		</div>
	);
};

export default Projects;
